import { FC } from 'react';
import { WistiaEmbed } from '../../WistiaEmbed';

interface Props {
  videoUrl?: string;
  imageUrl?: string | null;
}

const ArticleMedia: FC<Props> = ({ videoUrl, imageUrl }) => {
  const maxWidth = videoUrl ? 'max-w-6xl' : 'max-w-4xl';
  return (
    <div className={`mx-auto ${maxWidth}`}>
      {imageUrl && (
        <div>
          {/* eslint-disable-next-line @next/next/no-img-element, jsx-a11y/alt-text -- This image comes from Sanity */}
          <img src={imageUrl} />
        </div>
      )}
      {videoUrl && <WistiaEmbed assetId={videoUrl} />}
    </div>
  );
};

export default ArticleMedia;
